module.exports = __webpack_public_path__ + "img/9788962630855.2b994941.jpg";